import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "media-sidebar" }

import { inject } from 'vue';
import { invokeKey, navigateKey } from '@drapejs/core';
import * as media from '@/commands/media';
import MediaSidebarSearch from './sidebar/MediaSidebarSearch';
import MediaSidebarFilters from './sidebar/MediaSidebarFilters';


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaSidebar',
  setup(__props) {

const invoke = inject(invokeKey);
function logout() {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  invoke!(media.commands.logout, {
    url: window.location.href,
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MediaSidebarSearch)),
    _createVNode(_unref(MediaSidebarFilters))
  ]))
}
}

})